import Vue from 'vue';
import iView from 'view-design';
import i18n from './i18n';
import './assets/styles/theme/index.less'; // 引入自定义样式
import VCharts from 'v-charts';
import App from './app.vue';
import interceptor from './assets/js/interceptor';
import router from './router';
import store from './store';
import config from './config';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer'; // PC端详情页时  引用该组件 支持放大 旋转Vue.use(Viewer)
import initDirectives from '@/assets/js/directives';
import * as globalComponents from '@/components/';
import ajax from '@/assets/js/interceptor';
import VForm from '91-customize-form';
import '91-customize-form/dist/VFormDesigner-iView.css';
import './assets/styles/common/override-iview.css';
import { UTable, UTableColumn } from 'umy-ui';
import 'umy-ui/lib/theme-chalk/index.css';

Object.keys(globalComponents).forEach(component => {
  const componentName = upperFirst(
    camelCase(component)
  );
  Vue.component(componentName,
    globalComponents[component]);
});
initDirectives(Vue);
Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    el.focus();
  }
});
// Vue.use(iView); // 引用iView
Vue.use(iView, {
  i18n: function (path, options) {
    const value = i18n.t(path, options);
    if (value !== null && value !== undefined) return value;
    return '';
  }
}); // 引用iView
// 引入 u-table
Vue.component(UTable.name, UTable);
Vue.component(UTableColumn.name, UTableColumn);
Vue.use(VForm);
Vue.locale = () => {};

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    navbar: false,
    title: false,
    scalable: true,
    reset: false,
    loadingTips: '加载中...'
  }
});// 图片上传插件
Vue.use(VCharts); // 全局引用v-charts
Vue.prototype.$config = config; // 全局注册应用配置
// ajax.get('/v1/userInfo/canLoginApps').then(function (res) {
//   console.log('!!!!!!!!!!!', res);
//   if (res.data.data.code == 200) {
//     const canLoginApps = res.data.data;
//     console.log(canLoginApps);
//   }
// });
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
});
